import { getReinsuranceYear } from '@/utils/reinsuranceYear';

const drpLimitsBefore2019 = {
  butterfat: {
    min: 3.5,
    max: 5
  },
  protein: {
    min: 3,
    max: 4
  }
};

const drpLimitsFrom2019To2020 = {
  butterfat: {
    min: 3.25,
    max: 5
  },
  protein: {
    min: 2.75,
    max: 4
  }
};

const drpLimitsFrom2020To2025 = {
  butterfat: {
    min: 3.25,
    max: 5.5
  },
  protein: {
    min: 2.75,
    max: 4.5
  }
};

const drpLimitsFrom2026 = {
  butterfat: {
    min: 4,
    max: 6
  },
  protein: {
    min: 3.2,
    max: 4.5
  }
};

const getDrpLimitsByDate = (date: Date) => {
  const year = getReinsuranceYear(date);
  if (year < 2019) {
    return drpLimitsBefore2019;
  } else if (year >= 2019 && year < 2020) {
    return drpLimitsFrom2019To2020;
  } else if (year >= 2020 && year < 2026) {
    return drpLimitsFrom2020To2025;
  } else {
    return drpLimitsFrom2026;
  }
};

export const getDeclaredButterfatTestLimits = (date = new Date()): { min: number; max: number } =>
  getDrpLimitsByDate(date).butterfat;

export const getDeclaredProteinTestLimits = (date = new Date()): { min: number; max: number } =>
  getDrpLimitsByDate(date).protein;
